import { useContext } from 'react';

import { ModalContext } from './Modal';
import { ExternalModalContext } from './ExternalModal';

const useModal = () => useContext(ModalContext);

export default useModal;

export const useExternalModal = () => useContext(ExternalModalContext);
